import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleScroll = this.checkScroll.bind(this);
    window.addEventListener("load", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);

    this.checkScroll();
  }

  disconnect() {
    window.removeEventListener("load", this.handleScroll);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleScroll);
  }

  checkScroll() {
    const st = window.scrollY || document.documentElement.scrollTop;
    this.element.classList.toggle("is-active", st > 70);
  }

  scrollToTop(event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
